import { render, staticRenderFns } from "./DownloadListView.vue?vue&type=template&id=71b002ca&scoped=true"
import script from "./DownloadListView.vue?vue&type=script&lang=js"
export * from "./DownloadListView.vue?vue&type=script&lang=js"
import style0 from "./DownloadListView.vue?vue&type=style&index=0&id=71b002ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b002ca",
  null
  
)

export default component.exports